
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export const VacationCardSkeleton = () => {
  return (
    <Card className="overflow-hidden flex flex-col h-full">
      <Skeleton className="w-full h-48" />
      
      <CardContent className="p-4 flex flex-col flex-grow space-y-3">
        <div className="space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        
        <div className="flex items-center space-x-1">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-16 ml-2" />
        </div>
        
        <Skeleton className="h-16 w-full" />
        
        <div className="flex flex-wrap gap-1">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-24" />
        </div>
        
        <Skeleton className="h-6 w-24" />
        
        <Skeleton className="h-10 w-full mt-4" />
      </CardContent>
    </Card>
  );
};
